'use client';
import React, { useState } from "react";
import { IoShareSocialOutline } from "react-icons/io5";
import { useShare } from "@/src/hooks/useWebShare"; 
import { Share } from "../../share";

interface ShareButtonProps {
  jobId: string; // Make jobId a required prop
}

export const ShareButton: React.FC<ShareButtonProps> = ({ jobId }) => {
  const [isOpen, setIsOpen] = useState(false);

    const shareLink = `${window.location.origin}/careers/${jobId}`;

  return (
    <>
    <div
      className="px-[9px] py-2 rounded-lg border border-[#ecedf5] justify-start items-center gap-2 flex cursor-pointer"
      onClick={() => setIsOpen(true)}

    >
      <div className="w-6 h-6 relative flex items-center justify-center ">
        <IoShareSocialOutline className="text-secondary w-6 h-6" />
      </div>
    </div>
    <Share isOpen={isOpen} setIsOpen={setIsOpen} url={shareLink} />
    </>
  );
};
